window.addEventListener("load", function() {
	// size chart

	const embeddedSizeChartTrigger = document.querySelector('#opensizechart');
	const sideTriggerForSizeChart = document.querySelector('#js-fit-guide-popup');
	const sizeChartClose = document.querySelector('#sizeChartClose');

	// open popup using "What size should I order?"
	if(embeddedSizeChartTrigger) {
		embeddedSizeChartTrigger.addEventListener('click', function() {
			document.querySelector('.dynamic-fit-guide').classList.add('show-display');
			document.querySelector('.shopify-section-header').classList.add('js-redo-z-index-nav');
            document.querySelector('nav.breadcrumb.breadcrumb--product-single.js-breadcrumb').classList.add('js-redo-breadcrumb');
		
			document.querySelector('.overlay').classList.add('active');
			document.documentElement.classList.add("js-stop-scrolling");
	
			const expired = new Date().getTime() + 86400;
			localStorage.setItem('sizeChartModal', 'dismissed', expired);
	
			document.querySelector('body').classList.add('chart-active');
		})
	}
	

	// open popup for the side trigger "Size Guide"
	if (sideTriggerForSizeChart) {
		sideTriggerForSizeChart.addEventListener('click', function() {
			document.querySelector('.dynamic-fit-guide').classList.add('show-display');
			document.querySelector('.shopify-section-header').classList.add('js-redo-z-index-nav');
            document.querySelector('.nav.breadcrumb.breadcrumb--product-single.js-breadcrumb').classList.add('js-redo-breadcrumb');
			document.querySelector('.overlay').classList.add('active');
			document.documentElement.classList.add("js-stop-scrolling");
	
			const expired = new Date().getTime() + 86400;
			localStorage.setItem('sizeChartModal', 'dismissed', expired);
	
			document.querySelector('body').classList.add('chart-active');
		})
	};

	// auto appear "Size Guide" on the side
	if (document.querySelector('.template-product')) {
		setTimeout( function(){ 
			if (document.querySelector('#js-fit-guide-popup')) {
				document.querySelector('#js-fit-guide-popup').style.display = 'block';
			}
		}, 30000 );
	}

	// close event
	if (sizeChartClose) {
		sizeChartClose.addEventListener('click', function() {
			if(embeddedSizeChartTrigger && localStorage.getItem('sizeChartModal') != 'dismissed') {
				const expired = new Date().getTime() + 86400;

				embeddedSizeChartTrigger.style.display = "none";
				localStorage.setItem('sizeChartModal', 'dismissed', expired);
			}
		});
	}
});

$('#shoeSize').on('change', function() {
	if ( $( this ).val() && $('#shoeWidth').val() !== 'select') {
		let recommendedShoeSize;
		let sizeChart;
		let cleanedParse;
		let recommendedString = '<p id="fortressSize">Unfortunately, this style is not available in your size at this time.</p>';

		let shoppersShoeSize = $('#shoeSize').val();
		if (!$('#dynamic-fit-guide').attr("data-sizes")) {
			sizeChart =
				{
					"4.5": {
						"n": "",
						"r": "",
						"w": "35"
					},
					"5" : {
						"n": "35",
						"r": "35",
						"w": "35"
					},
					"5.5": {
						"n": "35",
						"r": "35",
						"w": "36"
					},
					"6": {
						"n": "36",
						"r": "36",
						"w": "36"
					},
					"6.5": {
						"n": "36",
						"r": "36",
						"w": "37"
					},
					"7": {
						"n": "37",
						"r": "37",
						"w": "37"
					},
					"7.5": {
						"n": "37",
						"r": "37",
						"w": "38"
					},
					"8" : {
						"n": "38",
						"r": "38",
						"w": "38"
					},
					"8.5": {
						"n": "38",
						"r": "38",
						"w": "39"
					},
					"9": {
						"n": "39",
						"r": "39",
						"w": "39"
					},
					"9.5": {
						"n": "39",
						"r": "39",
						"w": "40"
					},
					"10": {
						"n": "40",
						"r": "40",
						"w": "40"
					},
					"10.5": {
						"n": "41",
						"r": "41",
						"w": "41"
					},
					"11" : {
						"n": "41",
						"r": "41",
						"w": ""
					},
					"11.5": {
						"n": "",
						"r": "",
						"w": ""
					},
					"12": {
						"n": "",
						"r": "",
						"w": ""
					}
				};
			cleanedParse = sizeChart;
		} else {
			sizeChart = $('#dynamic-fit-guide').attr("data-sizes");
			let cleanedSizesObject = sizeChart.replace(/=>/g, ': ');
			cleanedParse = JSON.parse(cleanedSizesObject);
		}

		// if their size exists in the array
		if (cleanedParse[shoppersShoeSize]) {
			let sizeVariants = cleanedParse[shoppersShoeSize];

			// if they've set the width
			const shopperShoeWidth = $('#shoeWidth').val();

			// assign the right size
			if (shopperShoeWidth === 'narrow' ) {
				if (sizeVariants['n']) {
					recommendedShoeSize = sizeVariants['n'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			} else if (shopperShoeWidth === 'medium') {
				if (sizeVariants['r']) {
					recommendedShoeSize = sizeVariants['r'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			} else {
				if (sizeVariants['w']) {
					recommendedShoeSize = sizeVariants['w'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			}
		}
		$('#fortressSize').replaceWith(recommendedString);
	}
});

$('#shoeWidth').on('change', function() {
	if ( $( this ).val() && $('#shoeSize').val() !== 'select') {
		let recommendedShoeSize;
		let sizeChart;
		let cleanedParse;
		let recommendedString = '<p id="fortressSize">Unfortunately, this style is not available in your size at this time.</p>';

		let shoppersShoeSize = $('#shoeSize').val();
		if (!$('#dynamic-fit-guide').attr("data-sizes")) {
			sizeChart =
				{
					"4.5": {
						"n": "",
						"r": "",
						"w": "35"
					},
					"5" : {
						"n": "35",
						"r": "35",
						"w": "35"
					},
					"5.5": {
						"n": "35",
						"r": "35",
						"w": "36"
					},
					"6": {
						"n": "36",
						"r": "36",
						"w": "36"
					},
					"6.5": {
						"n": "36",
						"r": "36",
						"w": "37"
					},
					"7": {
						"n": "37",
						"r": "37",
						"w": "37"
					},
					"7.5": {
						"n": "37",
						"r": "37",
						"w": "38"
					},
					"8" : {
						"n": "38",
						"r": "38",
						"w": "38"
					},
					"8.5": {
						"n": "38",
						"r": "38",
						"w": "39"
					},
					"9": {
						"n": "39",
						"r": "39",
						"w": "39"
					},
					"9.5": {
						"n": "39",
						"r": "39",
						"w": "40"
					},
					"10": {
						"n": "40",
						"r": "40",
						"w": "40"
					},
					"10.5": {
						"n": "41",
						"r": "41",
						"w": "41"
					},
					"11" : {
						"n": "41",
						"r": "41",
						"w": ""
					},
					"11.5": {
						"n": "",
						"r": "",
						"w": ""
					},
					"12": {
						"n": "",
						"r": "",
						"w": ""
					}
				};
			cleanedParse = sizeChart;
		} else {
			sizeChart = $('#dynamic-fit-guide').attr("data-sizes");
			let cleanedSizesObject = sizeChart.replace(/=>/g, ': ');
			cleanedParse = JSON.parse(cleanedSizesObject);
		}

		// if their size exists in the array
		if (cleanedParse[shoppersShoeSize]) {
			let sizeVariants = cleanedParse[shoppersShoeSize];

			// if they've set the width
			const shopperShoeWidth = $('#shoeWidth').val();

			// assign the right size
			if (shopperShoeWidth === 'narrow' ) {
				if (sizeVariants['n']) {
					recommendedShoeSize = sizeVariants['n'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			} else if (shopperShoeWidth === 'medium') {
				if (sizeVariants['r']) {
					recommendedShoeSize = sizeVariants['r'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			} else {
				if (sizeVariants['w']) {
					recommendedShoeSize = sizeVariants['w'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			}
		}
		$('#fortressSize').replaceWith(recommendedString);
	}
});

$(".overlay, .em-close-btn").click(function(event){
	event.preventDefault();

	document.documentElement.classList.remove("js-stop-scrolling");
	$('.overlay').removeClass('active');
	$('.size-chart').removeClass('active');
	$('.dynamic-fit-guide').removeClass('show-display');
	$('.shopify-section-header').removeClass('js-redo-z-index-nav');
    $('nav.breadcrumb.breadcrumb--product-single.js-breadcrumb').removeClass('js-redo-breadcrumb');
  });
